.container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
}

.dealsList {
    flex: 1;
    overflow-y: auto;
    padding: 1rem;
    
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
}

.noDealsMessage {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    color: #666;
    font-style: italic;
}

:global {
    // Override Bootstrap's modal z-index
    .modal {
        z-index: 20000000 !important;
    }
    
    .modal-backdrop {
        z-index: 19999999 !important;
    }
} 